/**
 * Selling plan price: shows the price list matching the form's selected selling plan.
 * Subscription apps (Recharge) set the form's hidden "selling_plan" input without firing a change event,
 * so the form is watched for value attribute mutations as well.
 */
(() => {
  class SellingPlanPrice extends HTMLElement {
    connectedCallback() {
      this.form = document.forms[this.getAttribute('form-id')];

      if (!this.form) return;

      this.update = this.update.bind(this);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
      this.form.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.form?.removeEventListener('change', this.update);
    }

    update() {
      const sellingPlanId = new FormData(this.form).get('selling_plan') || '';
      const prices = Array.from(this.querySelectorAll(':scope > [data-selling-plan-id]'));
      const match = prices.find((price) => price.dataset.sellingPlanId === sellingPlanId)
        || prices.find((price) => price.dataset.sellingPlanId === '');

      prices.forEach((price) => {
        price.hidden = price !== match;
      });
    }
  }

  if (!window.customElements.get('selling-plan-price')) {
    window.customElements.define('selling-plan-price', SellingPlanPrice);
  }
})();
